module.exports = __webpack_public_path__ + "img/avatar5.f5044eed.png";